module.exports = __webpack_public_path__ + "img/snt.0bdde329.svg";